const mutations = {
  UPDATE(state: StateObj, { field = "none", value = null }) {
    state[field] = value;
  },
  RESET(state: StateObj) {
    if (state && localStorage) {
      localStorage.clear();
    }
  },
  GLOBAL_ALERT(state: StateObj, globalAlert: GlobalAlert) {
    state.globalAlert = globalAlert;
  },
  GLOBAL_LOADING(state: StateObj, globalLoading: boolean) {
    state.globalLoading = globalLoading === true;
  },
  UPDATE_AREA_NAME(state: StateObj, updatedAreaName: string) {
    state.updatedAreaName = updatedAreaName;
  }
};

export default mutations;
